import React from 'react'
import { Segment, Ref } from "semantic-ui-react";

export const SegmentWithRef = (React.forwardRef((props, ref) =>
  ref ? (
    <Ref innerRef={ref}>
      <Segment {...props} />
    </Ref>
  ) : (
    <Segment {...props} />
  )
))
